import React, { useState, useEffect } from 'react'
import { Query } from 'react-apollo'
import { Modal } from 'antd'
import { VERIFY_TOKEN } from '../../constants/graph/query'
import { setAccessToken, setRefreshToken } from '../../utils/local-data-service'
import PATH from '../../constants/path'

const SocialLogin = () => {
  const [accessToken, setAccessTokenState] = useState('')
  const [refreshToken, setRefreshTokenState] = useState('')

  const openModal = (contentText) => {
    Modal.error({
      title: 'พบข้อผิดพลาด',
      content: contentText,
      okText: 'ตกลง',
      onOk: () => { window.location = PATH.home },
    })
    setTimeout(() => {
      window.location = PATH.home
    }, 5000)
  }

  useEffect(() => {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    setAccessTokenState(url.searchParams.get('access_token'))
    setRefreshTokenState(url.searchParams.get('refresh_token'))
    if (params.get('success') === 'false') {
      openModal(params.get('message'))
    }
  })

  return (
    <Query
      query={VERIFY_TOKEN}
      variables={{
        token: accessToken,
      }}
    >
    {
      (res) => {
        if (res.data && res.data.verifyToken) {
          setAccessToken(accessToken)
          setRefreshToken(refreshToken)
          window.location = PATH.home
        }

        return (
          <div>
            <p>Logging in...</p>
          </div>
        )
      }
    }
    </Query>
  )
}

export default SocialLogin



// WEBPACK FOOTER //
// ./src/pages/social-login/index.jsx